import { Injectable } from 'angular-ts-decorators';
import { IHeroCustomizerV3Configuration } from './models/hero-customizer-v3.configuration';

const baseUrl = '/public-api/customizer';

@Injectable('customizerV3ApiService')
export class CustomizerV3ApiService {
  public static $inject: ReadonlyArray<string> = ['$http'];

  constructor(private $http: ng.IHttpService) { }

  public getHeroCustomizerV3(configurationId: string): ng.IPromise<IHeroCustomizerV3Configuration> {
    const url = `${baseUrl}/hero-customizer-v3/${configurationId}`;

    return this.$http
      .get<IHeroCustomizerV3Configuration>(url)
      .then((response: ng.IHttpResponse<IHeroCustomizerV3Configuration>) => response.data);
  }
}
